import React from 'react';
import { useSelector } from 'react-redux';
import { cleanXSS } from '../../../helpers/string';
import '../forms.css';
import Copy from '../../copy';

const Label = props => {
	const [editMode, setEditMode] = React.useState(false);
	const [value, setValue] = React.useState(props.value);
	const { showFormHelp } = useSelector(state => state.ui);

	const onSave = () => {
		setEditMode(false);
		props.onSave && props.onSave(value);
	};

	const { id, error, label, help, suffix, heading, className, multiline, ...rest } = props;

	const pencil = inline => {
		return (
			<i
				title={`Edit ${label}`}
				onClick={() => setEditMode(true)}
				className={`pointer fa fa-pencil ml10 ${inline ? '' : 'edit-pencil'}`}
			/>
		);
	};
	return (
		<div id={id} className={`mb10 ${error ? 'form-group has-error' : ''}`} data-testid={rest['data-testid']}>
			{!heading && <label htmlFor="item-name">{label}</label>}
			{showFormHelp && help && (
				<span className="form-control-help">
					<Copy value={help} />
				</span>
			)}
			{editMode ? (
				<div className="flex">
					{multiline ? (
						<textarea
							rows="4"
							onChange={e => setValue(e.target.value)}
							className="flex-grow form-control"
							value={value}
						/>
					) : (
						<input onChange={e => setValue(e.target.value)} value={value} className="flex-grow form-control" />
					)}
					<button title="Save change" onClick={() => onSave()} className="btn btn-xs btn-success">
						<i className="fa fa-check" />
					</button>
				</div>
			) : (
				<div className="flex copy">
					<div className={`${className} ${error ? 'help-block' : ''} ${heading ? 'text-lg' : ''}`}>
						<span
							className={suffix ? 'mr10' : ''}
							dangerouslySetInnerHTML={{
								__html: value ? cleanXSS(value.toString()).replace('\\n', '<br />') : '-',
							}}
						/>
						{suffix && suffix()}
						{props.onSave && multiline && pencil(true)}
					</div>
					{props.onSave && !multiline && pencil(false)}
				</div>
			)}
		</div>
	);
};

export default Label;
